import { useEffect } from "react";

// A query-string value is absent as null, and localStorage stringifies whatever
// it is given — so writing an absent ref stores the literal "null" and destroys
// a referral captured on an earlier page. Treat those as empty.
export const cleanRefValue = (value) => {
  if (value === null || value === undefined) return "";
  const trimmed = String(value).trim();
  if (!trimmed || trimmed === "null" || trimmed === "undefined") return "";
  return trimmed;
};

export const getStoredReferral = () => {
  try {
    return {
      ref: cleanRefValue(localStorage.getItem("ref")),
      compaign_name: cleanRefValue(localStorage.getItem("compaign_name")),
    };
  } catch (e) {
    return { ref: "", compaign_name: "" };
  }
};

const useReferralLink = (ref, compaign_name) => {
  const incomingRef = cleanRefValue(ref);
  const incomingCampaign = cleanRefValue(compaign_name);

  useEffect(() => {
    if (!incomingRef) return;

    try {
      localStorage.setItem("ref", incomingRef);
      if (incomingCampaign) {
        localStorage.setItem("compaign_name", incomingCampaign);
      }
    } catch (e) {
      // private mode / storage disabled — the URL still carries the ref
    }

    // Drop the parameters from the address bar once captured, so the referral
    // is not re-shared or crawled. The value lives in localStorage from here.
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has("ref") || url.searchParams.has("compaign_name")) {
        url.searchParams.delete("ref");
        url.searchParams.delete("compaign_name");
        window.history.replaceState(
          window.history.state,
          "",
          url.pathname + url.search + url.hash
        );
      }
    } catch (e) {
      // replaceState unavailable — harmless, the capture already happened
    }
  }, [incomingRef, incomingCampaign]);

  return incomingRef || getStoredReferral().ref;
};

export default useReferralLink;
